module.exports = __webpack_public_path__ + "static/media/Berkley-Argentina-Seguros2.a5fac481.png";